import React from 'react';
import { css } from '@emotion/core';
import Markdown from 'react-remarkable';
import moment from 'moment';

import Magazine from '../Magazine/Magazine';
import Newsletter from '../Newsletter/Newsletter';
import Link from '../../../shared/Link/Link';
import Arrow from '../../../shared/Icons/Arrow';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

import './ModuleBlogNewsletter.scss';

const cleanUrl = string => {
  const regex = /([^\d\w-]+)/g;
  if (!!string) {
    return string.replace(regex, '-');
  }
};

const ModuleBlogNewsletter = ({
  hasBlog,
  posts,
  primaryColor,
  secondaryColor,
  home,
  blogNewsletterVersion,
  coloredBackgroundMagazine,
  navigationDotsMagazine,
  sliderCircleArrowsMagazine,
  isMobile,
}) => {
  const magazineSectionStyle = css`
    &.colored-bg {
      background-color: #f8f8f8;
      border-radius: 6px;
      display: flex;
      flex-direction: column;

      &
        .magazine
        > .magazine-box
        > .articles-list
        > .slick-slider
        > .slick-list {
        background-color: transparent;
        .slick-track {
          background-color: #f8f8f8;
          border: none;
        }
      }
    }
  `;

  const generalStyle = css`
    @media screen and (max-width: 992px) {
      gap: 8px;
      // margin-bottom: 4rem;
    }
    &.version-1 > .row {
      width: 100%;
      max-width: 100%;
      padding-right: 3%;
      padding-left: 3%;
      @media screen and (max-width: 992px) {
        gap: 15px;
      }

      .col-lg-5 {
        padding-left: 5px;
        @media screen and (max-width: 992px) {
          padding-right: 0px;
          padding-left: 0px;
        }
      }
      .col-lg-7 {
        padding-right: 0px;
        padding-left: 25px;
        @media screen and (max-width: 992px) {
          padding-right: 0px;
          padding-left: 0px;
        }
      }
    }
    &.version-2 > .row {
      width: 100%;
      @media screen and (max-width: 992px) {
        gap: 20px;
      }
      max-width: 100%;
      .col-lg-5 {
        padding-left: 10px;
        padding-right: 0px;
        @media screen and (max-width: 992px) {
          padding-left: 0px;
        }
      }
      .col-lg-7 {
        padding-right: 0px;
        padding-left: 0px;
        @media screen and (max-width: 992px) {
          padding-right: 27px;
          padding-left: 0px;
        }
        @media screen and (max-width: 768px) {
          padding-right: 0px;
          padding-left: 0px;
        }
      }
    }
    &.version-3 > .row {
      width: 100%;
      max-width: 100%;
      @media screen and (max-width: 992px) {
        gap: 15px;
      }

      .col-lg-5 {
        padding-left: 15px;
        padding-right: 0px;
        @media screen and (max-width: 992px) {
          padding-left: 0px;
        }
      }
      .col-lg-7 {
        padding-right: 0px;
        padding-left: 27px;
        @media screen and (max-width: 992px) {
          padding-right: 0px;
          padding-left: 0px;
        }
      }
    }
  `;

  const blogHeaders = css`
    &.magazine-headers {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2rem 2rem 0;

      a {
        display: flex;
        align-items: baseline;
        gap: 5px;
        margin-right: 8px;
        &:hover,
        &:active,
        &:focus {
          text-decoration: none;
        }

        p {
          font-size: 14px;
          color: ${primaryColor};
        }

        svg {
          width: 10px;
          height: 10px;
        }
      }

      p {
        font-weight: 500;
        margin: 0;
        font-size: 22px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
    &.magazine-headers.mobile {
      display: flex;
      margin-bottom: 0px;
      width: 100%;
      @media screen and (min-width: 993px) {
        display: none;
      }
    }
  `;

  const renderMagazine = () => {
    if (isMobile) {
      return renderMagazineMobile();
    } else {
      return renderMagazineDesktop();
    }
  };

  const renderMagazineDesktop = () => {
    return (
      <div className="hidden-mobile">
        {blogNewsletterVersion === 2 && (
          <div className="magazine-headers" css={blogHeaders}>
            <p>Blog</p>
            <h2 style={{ display: 'none' }}>Blog</h2>
            <Link to="/blog">
              <p>Visualizza tutti</p>
              <Arrow />
            </Link>
          </div>
        )}
        <Magazine
          posts={posts}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          blogNewsletterVersion={blogNewsletterVersion}
          navigationDotsMagazine={navigationDotsMagazine}
          sliderCircleArrowsMagazine={sliderCircleArrowsMagazine}
        />
      </div>
    );
  };

  const renderMagazineMobile = () => {
    return (
      <div className="hidden-desktop mobile-module-blog-newsletter">
        {!!hasBlog && posts.length > 0 && (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '2rem 0 1rem',
              }}
            >
              <div
                style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                }}
              >
                Blog
                <h2 style={{ display: 'none' }}>Blog</h2>
              </div>
              <div>
                <Link
                  aria-label="Guarda tutti i nostri articoli"
                  href="/blog"
                  style={{ color: primaryColor }}
                >
                  Vedi tutti
                  <Arrow style={{ width: 14, height: 14, marginLeft: 4 }} />
                </Link>
              </div>
            </div>
            <div className="mobile-blog-list-container">
              {posts.map((post, index) => {
                const postLink = `/blog/${post.id}-${!!post.title &&
                  cleanUrl(post.title)}`;
                console.log('post.excerpt', post.excerpt);
                return (
                  <div className="mobile-blog-container">
                    {!!post.featuredImageUrl && (
                      <div className="mobile-blog-image">
                        <Link
                          to={postLink}
                          aria-label={`Leggi il nostro articolo "${post.title}"`}
                        >
                          <ImageDispatcher
                            alt={`Immagine di copertina dell'articolo "${post.title}"`}
                            src={post.featuredImageUrl}
                            className={index >= 1 ? 'lazyload' : ''}
                          />
                        </Link>
                      </div>
                    )}
                    <h3 style={{ display: 'none' }}>{post.title}</h3>
                    <div className="mobile-blog-text-container">
                      {!!post.title && (
                        <Link
                          href={postLink}
                          aria-label={`Leggi il nostro articolo "${post.title}"`}
                          style={{ color: primaryColor }}
                        >
                          <div className="mobile-blog-title">{post.title}</div>
                        </Link>
                      )}
                      {!!post.date && (
                        <div className="mobile-blog-date">
                          {moment(post.date)
                            .locale('it')
                            .format('DD MMMM YYYY')}
                        </div>
                      )}
                      {!!post.excerpt && (
                        <div className="mobile-blog-description">
                          {post.excerpt
                            .split('**')
                            .join('')
                            .split('<h1>')
                            .join('')
                            .split('</h1>')
                            .join('')
                            .split('<h2>')
                            .join('')
                            .split('</h2>')
                            .join('')
                            .split('<h3>')
                            .join('')
                            .split('</h3>')
                            .join('')
                            .split('\n\n')
                            .join('\n')}
                          {/* <Markdown
                            source={post.excerpt
                              .split('**')
                              .join('')
                              .split('<h1>')
                              .join('')
                              .split('</h1>')
                              .join('')
                              .split('<h2>')
                              .join('')
                              .split('</h2>')
                              .join('')
                              .split('<h3>')
                              .join('')
                              .split('</h3>')
                              .join('')
                              .split('\n\n')
                              .join('\n')}
                          /> */}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      <div
        className={`container version-${blogNewsletterVersion}`}
        style={{ maxWidth: '94%' }}
        css={generalStyle}
      >
        <div
          className="row"
          style={{
            flexDirection: blogNewsletterVersion !== 1 ? 'row-reverse' : 'row',
            margin: '0px',
          }}
        >
          <div
            className={`${
              !!hasBlog && posts.length > 0 ? 'col-lg-5' : 'col-sm-12'
            }`}
          >
            <Newsletter
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              newsletterTitle={home.newsletterTitle}
              isFullWidth={!hasBlog || posts.length < 1}
              blogNewsletterVersion={blogNewsletterVersion}
            />
          </div>
          {!!hasBlog && posts.length > 0 && (
            <div
              className={`col-lg-7 ${
                coloredBackgroundMagazine && !isMobile ? 'colored-bg' : ''
              }`}
              css={magazineSectionStyle}
            >
              {renderMagazine()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModuleBlogNewsletter;
//blogNewsletterVersion 1: Newsletter + Magazine showing 2 slides with image, title and a text preview;
//blogNewsletterVersion 2: Magazine showing only the image, the title and a "read more" button;
//blogNewsletterVersion 3: same as 1 but with Newsletter and Magazine in reverse order.

//N.B blogNewsletterVersion provides for colored background and navigation dots.
//It's necessary to insert value === 1 into farmakom_test/store_visual_variants table, fields:
// background_variation_magazine
// slider_navigation_dots_magazine
